/* eslint-disable no-nested-ternary */
import React, { useState } from 'react';
import SvgIcon from "@/pages/home/components/SvgIcon";
import './index.scss';
import CommonBubble from '@home/components/CommonBubble';

export default function TipContext(props: any) {
  const {
    tipText,
    className,
    placement,
    AWidth,
    style,
    type,
    placementOffset,
    selected = false,
    onClick,
    overlayClassName,
    overlayMaxHeight,
    styles,
    ...remains
  } = props;
  // type 要传入对象一个是默认， 一个是hover之后  ， 不传入按提示的展示
  const [isIconHover, setIsIconHover] = useState(false);
  
  return (
    <div
      onMouseOver={() => {
        setIsIconHover(true);
      }}
      onMouseOut={() => {
        setIsIconHover(false);
      }}
      onClick={onClick}
      className={`db-tipcontext-icon ${className ? className : ''}`}
      style={styles}
    >
      <CommonBubble
        dark
        style={style ? style : { maxWidth: AWidth }}
        placement={placement ? placement : 'top'}
        content={tipText && <div className='db-tipcontext-content' style={{maxHeight: overlayMaxHeight?overlayMaxHeight:'unset'}} dangerouslySetInnerHTML={{ __html: tipText }}></div>}
        placementOffset={placementOffset ? placementOffset : 10}
        className={`db-tipcontext-bubble ${overlayClassName ? overlayClassName : null}`}
        // trigger={'click'}
      >
        <div className="db-tipcontext-box">
          {selected ? (
            <SvgIcon
              type={
                isIconHover
                  ? type?.hover
                    ? type.hover
                    : 'action-tab-icon'
                  : type?.default
                    ? type.default
                    : 'tab-tip-icon'
              }
            />
          ) : (
            <SvgIcon
              type={
                isIconHover
                  ? type?.hover
                    ? type.hover
                    : 'alert-circle-action'
                  : type?.default
                    ? type.default
                    : 'alert-circle-m'
              }
            />
          )}
        </div>
      </CommonBubble>
    </div>
  );
}
